import { computed, ref, watch } from 'vue';
import type { ConditionItemProps } from './ConditionItem.vue';
import { useInjectedConditionEditor } from './useWorkflowConditionEditorProvider';

export const useConditionItem = (props: ConditionItemProps) => {
  const conditionEditor = useInjectedConditionEditor();

  const propertyOptions = computed(() => {
    return conditionEditor.definitions.value.map(x => x.name);
  });

  const localProperty = computed(
    () => conditionEditor.definitions.value.find(f => f.property === props.expressionCondition.property)?.name ?? ''
  );

  const selectedPropertyString = ref<string>(localProperty.value);

  const currentConditionDefinition = computed(
    () => conditionEditor.definitions.value.find(x => x.name === selectedPropertyString.value)!
  );

  const onPropertyChange = (val: string) => {
    const filter = conditionEditor.definitions.value.find(x => x.name === val)!;
    conditionEditor.changeCondition({ index: props.index, property: filter.property });
  };

  const removeCondition = () => {
    conditionEditor.removeCondition({ index: props.index });
  };

  watch(
    () => localProperty.value,
    property => (selectedPropertyString.value = property)
  );

  return { selectedPropertyString, propertyOptions, currentConditionDefinition, onPropertyChange, removeCondition };
};
